import { staticPath } from "faqSrc/lib/$path";
import React from "react";
import styled from "styled-components";
import Image from "~/components/atoms/Image";
import { colorBlack } from "~/lib/constants";

const ScrollToTopButton: React.FC = () => {
  return (
    <ScrollToTopLink href="#page-top">
      <IconWrap>
        <Image
          alt="icon top"
          ampLayout="fixed"
          height={16}
          layout="fixed"
          src={staticPath.img.icon_arrow_up_svg}
          width={13}
        />
      </IconWrap>
      <Text>トップ</Text>
    </ScrollToTopLink>
  );
};

const ScrollToTopLink = styled.a`
  align-items: center;
  background-color: #fff;
  border-radius: 40px;
  border: 2px solid ${colorBlack[300]};
  box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.1);
  display: flex;
  font-size: 15px;
  line-height: 15px;
  height: 40px;
  justify-content: center;
  padding: 0 14px;
  gap: 5px;

  &:hover {
    background-color: ${colorBlack[100]};
  }
`;

const IconWrap = styled.div`
  //   align-items: center;
  //   display: flex;
  //   justify-content: center;
`;

const Text = styled.div`
  color: ${colorBlack[400]};
  font-size: 15px;
  font-weight: 700;
  line-height: 15px;
`;

export default ScrollToTopButton;
